<template>
  <dialog
    :id="id"
    class="custom-modal"
    :class="[modalClass, variant, ]"
    @animationend="focusElement()"
    @keydown.esc.prevent="hide(id)"
  >
    <div class="modal-header">
      <div class="flex-vcenter">
        <div
          v-if="variant !== 'default'"
          class="modal-icon"
        >
          <UilExclamationTriangle
            v-if="variant === 'warning'"
            size="24"
          />
          <UilExclamationOctagon
            v-else-if="variant === 'error'"
            size="24"
          />
        </div>
        <div class="title-container">
          <h1
            v-if="$slots.title"
            class="s6 bold"
          >
            <!-- @slot Titre de la modale. -->
            <slot name="title" />
          </h1>
          <h2
            v-if="$slots.subtitle"
            class="text-regular"
          >
            <!-- @slot Sous-titre de la modale. -->
            <slot name="subtitle" />
          </h2>
        </div>
      </div>
      <div class="flex-vcenter">
        <button
          class="button flex-vcenter"
          @click="hide(id)"
        >
          <UilTimes size="24" />
        </button>
      </div>
    </div>

    <div class="modal-body">
      <!-- @slot Contenu de la modale. -->
      <slot name="content" />
    </div>

    <div
      v-if="$slots.footer"
      class="modal-footer"
    >
      <!-- @slot Footer de la modale. -->
      <slot name="footer" />
    </div>
  </dialog>
</template>

<script>
import { UilExclamationOctagon, UilExclamationTriangle, UilTimes } from "@iconscout/vue-unicons";

/**
 * Affiche une modale interactive au centre de l'écran.
 */
export default {
  name: "Modal",
  components: {
    UilExclamationTriangle,
    UilExclamationOctagon,
    UilTimes,
  },
  props: {
    /**
     * Identifiant HTML de la modale.
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * Ajoute une classe personnalisée.
     */
    modalClass: {
      type: String,
      default: null,
    },
    /**
     * Change les couleurs de la modale selon son utilisation.
     */
    variant: {
      type: String,
      validator: (value) => ["default", "warning", "error"].includes(value),
      default: "default",
    },
    /**
     * Sélecteur HTML à focus (dans la modale).
     */
    elementToFocus: {
      type: String,
      default: null,
    },
  },

  emits: ["hidden"],

  methods: {
    /**
     * Focus le sélecteur HTML via le querySelector.
     */
    focusElement() {
      if (this.elementToFocus) {
        const input = document.querySelector(`#${this.id} ${this.elementToFocus}`);
        if (input) {
          input.focus();
        }
      }
    },

    hide(id) {
      this.$modal.hide(id);
      this.$emit("hidden");
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/modals/modal.scss";
</style>
